const LETTERS = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];

export default function (number) {
  if (LETTERS[number]) {
    return LETTERS[number].toUpperCase();
  }

  return false;
}
